var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-popup",
    {
      staticClass: "mini-login-wrap",
      attrs: {
        "close-on-click-overlay": false,
        "safe-area-inset-bottom": true,
        position: "bottom",
        round: "",
      },
      model: {
        value: _vm.modal,
        callback: function ($$v) {
          _vm.modal = $$v
        },
        expression: "modal",
      },
    },
    [
      _c("h3", [_vm._v("账户授权")]),
      _vm.closeable
        ? _c("div", { staticClass: "close-item", on: { click: _vm.goBank } }, [
            _c("i", { staticClass: "iconfont icon-close" }),
          ])
        : _vm._e(),
      _vm.step === 1
        ? [
            _c("p", { staticClass: "main-title" }, [
              _vm._v("同意将账户以下信息授权给 优版权"),
            ]),
            _c("p", { staticClass: "subtitle" }, [
              _c("i", { staticClass: "van-checkbox" }),
              _vm._v(" 获取你的登录手机号 "),
            ]),
            _c(
              "div",
              {
                staticClass: "btn-filed",
                on: {
                  click: function ($event) {
                    ;(_vm.step = 2), _vm.getCode()
                  },
                },
              },
              [
                _c(
                  "van-button",
                  { attrs: { block: "", round: "", type: "primary" } },
                  [_vm._v("确认授权")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.step === 2
        ? [
            _c(
              "van-form",
              { ref: "form", on: { submit: _vm.toRegister } },
              [
                _vm.phone
                  ? _c("p", { staticClass: "user-phone" }, [
                      _vm._v(_vm._s(_vm._f("hidePhone")(_vm.phone))),
                    ])
                  : _vm._e(),
                _vm.isVerifyCodeLogin
                  ? [
                      _c("van-field", {
                        staticClass: "code-filed",
                        attrs: {
                          maxlength: 6,
                          rules: _vm.rules.code,
                          clearable: "",
                          placeholder: "请输入短信验证码",
                          type: "number",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button",
                              fn: function () {
                                return [
                                  _c(
                                    "van-button",
                                    {
                                      staticClass: "code-btn",
                                      attrs: {
                                        disabled: _vm.codeDisabled,
                                        loading: _vm.codeLoading,
                                        "native-type": "button",
                                        type: "primary",
                                      },
                                      on: { click: _vm.getCode },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.remainTime
                                              ? _vm.remainTime + " s"
                                              : "获取验证码"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1612004672
                        ),
                        model: {
                          value: _vm.verifyCode,
                          callback: function ($$v) {
                            _vm.verifyCode =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "verifyCode",
                        },
                      }),
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "btn-filed" },
                  [
                    _c(
                      "van-button",
                      {
                        attrs: {
                          disabled: _vm.disabled,
                          loading: _vm.submitLoading,
                          block: "",
                          "native-type": "submit",
                          round: "",
                          type: "primary",
                        },
                      },
                      [_vm._v(" 授权验证 ")]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }